import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { RouterConstants } from '../../../../core/routing/constants/app-paths.constant';
import { AddNewModelSKU } from '../../interface/oem-portal-interface.i';
import { OemService } from '../../../../../app/core/routing/services/oem/oem.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { Utils } from '../../../../../app/common/utils/utils';
import { LANGUAGE_MAPPINGS } from '../../../../common/constants/language-mappings.const';
import { OemStoreService } from '../../store/oem.store';
import { OemConstants } from '../../../../core/routing/services/oem/constants/oem.constants';
import { GoogleAnalyticsService } from '../../../../modules/google-analytics/google-analytics.service';
import { IPOSValidator } from '../../../../../app/common/validators/validators';

@Component({
  selector: 'iposcen-new-sku-info',
  templateUrl: './new-sku-info.component.html',
  styleUrls: ['./new-sku-info.component.scss']
})
export class NewSkuInfoComponent implements OnInit {
  @Input() autoID: string;
  @ViewChild('windowsos') windowsos: ElementRef;
  @ViewChild('chromebookos') chromebookos: ElementRef;
  @ViewChild('linuxos') linuxos: ElementRef;
  @ViewChild('uwpos') uwpos: ElementRef;
  @Output() readonly setSideNavValue = new EventEmitter();
  @Output() isEditFlow = new EventEmitter();
  wantsMoreLang: boolean;
  modelSKUInfoForm: FormGroup;
  displayName: any;
  displayNameMulti: any;
  systemID: any;
  systemModels: any;
  isWindowsOS: boolean;
  isChromebookOS: boolean;
  isLinuxOS: boolean;
  isUwpOS: boolean;
  noOS: boolean;
  isSubmitted: boolean;
  modelSKUName = [];
  tempVar: any;
  popDisplay: string = OemConstants.popDisplay;
  englishPalceholder: string = OemConstants.englishPalceholder;
  langPlaceholder: string = OemConstants.langPlaceholder;
  addLocalizedDisplayName: string = OemConstants.addLocalizedDisplayName;
  systemId: string = OemConstants.systemId;
  systemIdPlaceholder: string = OemConstants.systemIdPlaceholder;
  systemModelsTips: string = OemConstants.systemModelsTips;
  systemModelsPlaceholder: string = OemConstants.systemModelsPlaceholder;
  addButton: string = OemConstants.addButton;
  cancelButton: string = OemConstants.cancelButton;
  saveButton: string = OemConstants.saveButton;
  payload;
  systemIdData;
  errorCheckSyatemId;
  systemIDToDE: string;
  isOperatingSystem = new Map();
  langList = [];
  systemModelList = [];
  newAttribute: any = {};
  newModel: any = {};
  newInputModel: string;
  modelSKUList = new Map();
  editModelSKUList = new Map();
  languageList = new Map();
  editLanguageList = new Map();
  displayValue = new Map();
  editDisplayValue = new Map();
  editEnglish;
  checkduplicateLanguage = new Map();
  partnerName: string = sessionStorage.getItem('partnerName');
  GeneratedAutoId: string;
  languageSelected: string;
  private ngUnsubscribe = new Subject();
  disableSubmit: boolean;
  modelSKUListData: any[];
  editModelSKUListData: any[];
  languages = ['Arabic', 'Chinese - Simplified', 'Chinese - Traditional', 'Czech', 'Danish', 'Dutch', 'Finnish', 'French', 'German', 'Greek', 'Hebrew', 'Hungarian','Icelandic', 'Indonesian', 'Italian', 'Japanese', 'Korean', 'Norwegian', 'Polish', 'Portuguese - Brazil', 'Portuguese - Portugal', 'Romanian', 'Russian', 'Slovak', 'Spanish - Mexico', 'Spanish', 'Swedish', 'Thai', 'Turkish', 'Ukrainian', 'Vietnamese']
  checkduplicateSku: any;
  initLang: string;
  checkError: any;
  englishValue: any;
  checkInputEmptyError = false;
  checkEmptyInputField: boolean;
  disableAdd: boolean;
  disableAddLang: boolean;
  langIsSelected: boolean;
  abbreviatedLang: string;
  editData: any;
  valueOfSystemID: string;
  valueForSystemModel: string;
  valueOfOS: string;
  englishDisplayName: string;
  presentOS = [];
  allValues = [];
  isLast: boolean;
  checkduplicateeditSku: boolean;
  isLastModelSKU: boolean;
  crossIcon = OemConstants.cross_icon;
  PAT_SYSID = IPOSValidator.SYSTEMID_REGEX;
  isSystemIdExists: boolean;
  systemIDExistsErrorMsg = OemConstants.SYSTEMID_EXISTS_DESC;

  constructor(private router: Router, private fb: FormBuilder, private oemservice: OemService, private oemStore: OemStoreService, private googleAnalyticsService: GoogleAnalyticsService) { }

  ngOnInit(): void {
    if (this.oemStore.oemStoreData) {
      this.autoID = this.oemStore.oemStoreData;
    }
    this.wantsMoreLang = false;
    this.errorCheckSyatemId = false;
    this.isSystemIdExists = false;
    this.modelSKUInfoForm = this.fb.group({
      displayName: new FormControl(this.displayName, [Validators.required]),
      systemID: new FormControl(this.systemID, [Validators.required]),
      systemModels: new FormControl(this.systemModels, [Validators.required])
    });
    this.isWindowsOS = false;
    this.isChromebookOS = false;
    this.isLinuxOS = false;
    this.isUwpOS = false;
    this.noOS = true;
    this.isSubmitted = false;
    this.initLang = "IPOS Language";
    this.checkError = false;
    this.disableSubmit = false;
    this.checkEmptyInputField = true;
    this.disableAdd = true;
    this.disableAddLang = true;
    this.langIsSelected = true;
    if (this.autoID) {
      this.isEditFlow.emit(true);
      this.oemservice.setAutoId(this.autoID);
      this.getSKUInfoByAutoID();
      this.isLast = false;
      this.checkEmptyInputField = false;
      this.checkduplicateSku = true;
      this.disableAdd = true;
    } else {
      this.isEditFlow.emit(false);
    }

  }

  getSKUInfoByAutoID() {
    this.editDisplayValue.clear();
    this.oemservice.getALLModelSKUFuncByAutoID()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {

        var displayName = data.modelSKU['displayName'];
        if (typeof this.parseJson(displayName) === 'object') {
          var disName = JSON.parse(data.modelSKU['displayName']);
          this.langList = [];
          for (let element in disName) {
            if (element === 'en_US') {
              this.englishDisplayName = disName[element];
            } else {
              this.langList.push({
                selectedLan: this.getlangName(element),
                listOflan: this.languages,
                name: disName[element]
              });

              this.makeMandatory(this.langList[2]);
            }
          }
          this.editEnglish = disName['en_US'];
          delete disName['en_US']
          Object.keys(disName).forEach((value, index) => {

            this.editLanguageList.set(index, value);

          })
          Object.values(disName).forEach((value, index) => {

            this.editDisplayValue.set(index, value);

          });
        } else {
          this.englishDisplayName = displayName;
          this.editEnglish = displayName;
        }
        this.disableAddLang = false;
        this.langIsSelected = false;
        this.valueOfSystemID = data.modelSKU['systemID'];
        this.valueOfOS = data.modelSKU['operatingSystem'];
        this.presentOS = this.valueOfOS.split(',');
        if (this.presentOS.includes('Windows') || this.presentOS.includes('Linux') || this.presentOS.includes('Chromebook') || this.presentOS.includes('UWP')) {
          if (this.presentOS.includes('Windows')) {
            this.isWindowsOS = true;
            this.isOperatingSystem.set('Windows', true)
          }
          if (this.presentOS.includes('Linux')) {
            this.isLinuxOS = true;
            this.isOperatingSystem.set('Linux', true)
          }
          if (this.presentOS.includes('Chromebook')) {
            this.isChromebookOS = true;
            this.isOperatingSystem.set('Chromebook', true)
          }
          if (this.presentOS.includes('UWP')) {
            this.isUwpOS = true;
            this.isOperatingSystem.set('UWP', true)
          }
        }
        this.valueForSystemModel = data.modelSKU['systemModels'];
        try {

          this.allValues = JSON.parse(this.valueForSystemModel);
          this.allValues.forEach((data, index) => {
            this.getModelSkU(index, data);
            this.editModelSKUList.set(index, data);

          })
        } catch {
          let temp = [];
          temp.push(data.modelSKU['systemModels']);
          this.allValues = temp;

          this.editModelSKUList.set(0, data.modelSKU['systemModels']);


          this.getModelSkU(0, data.modelSKU['systemModels']);
        }
      })
  }

  parseJson(code) {
    try {
      return JSON.parse(code);
    } catch (e) {
      return code;
    }
  }

  getlangName(code: string) {

    return Utils.decodeLanguageByCodeout(code);

  }
  checkSystemId(data) {
    this.errorCheckSyatemId = false;
    this.isSystemIdExists = false;
    if (data.length <= 50) {
      this.systemIdData = data;
      if (data[0] === '_' || data[data.length - 1] === '_' || /[a-z]/.test(data) || !this.PAT_SYSID.test(data) || data.indexOf(' ') !== -1 || data.search('__') !== -1) {
        this.errorCheckSyatemId = true;
      }
    } else {
      data = this.systemIdData;
    }

  }

  isOS(data) {
    if (this.isOperatingSystem.has(data)) {
      this.isOperatingSystem.delete(data);
    } else {
      this.isOperatingSystem.set(data, true);
    }
  }

  getDisplayValue(index, data) {
    data = data.trim(' ');
    if(data === '' || data === null) {
      this.disableAdd = false;
    } else {
      this.disableAdd = true;
    }

    if (this.autoID) {
      if (index === -1) {
        this.makeMandatory(data);
        this.editEnglish = data;
        this.checkInputEmptyError = data === '' || data === ' ' ? true : Array.from(this.editDisplayValue.values()).includes('');
      } else {
        this.disableAddLang = false;
        this.editDisplayValue.set(index, data);
        this.checkInputEmptyError = Array.from(this.editDisplayValue.values()).includes('');
      }
    }
    else {
      if (index !== -1) {
        this.makeMandatory(data);
        this.displayValue.set(index, data);
        this.checkInputEmptyError = data === '' || data === ' ' ? true : Array.from(this.displayValue.values()).includes('');
      }
      else {
        this.displayValue.set(index, data);
        this.checkInputEmptyError = Array.from(this.displayValue.values()).includes('');
        this.englishValue = data;
        this.disableAddLang = false;
        this.langIsSelected = false;
      }
    }


  }

  onSelectChange(value, index) {
    this.langIsSelected = false;
    this.langList[index].selectedLan = value;
    this.disableSubmit = false;
    if (value === 'Arabic') {
      this.abbreviatedLang = 'ar_SA';
    } else if (value === 'Chinese - Simplified') {
      this.abbreviatedLang = 'zh_CN';
    } else if (value === 'Chinese - Traditional') {
      this.abbreviatedLang = 'zh_TW';
    } else if (value === 'Czech') {
      this.abbreviatedLang = 'cs_CZ';
    } else if (value === 'Danish') {
      this.abbreviatedLang = 'da_DK';
    } else if (value === 'Dutch') {
      this.abbreviatedLang = 'nl_NL';
    } else if (value === 'Finnish') {
      this.abbreviatedLang = 'fi_FI';
    } else if (value === 'French') {
      this.abbreviatedLang = 'fr_FR';
    } else if (value === 'German') {
      this.abbreviatedLang = 'de_DE';
    } else if (value === 'Greek') {
      this.abbreviatedLang = 'el_GR';
    } else if (value === 'Hebrew') {
      this.abbreviatedLang = 'he_IL';
    } else if (value === 'Hungarian') {
      this.abbreviatedLang = 'hu_HU';
    } else if (value === 'Indonesian') {
      this.abbreviatedLang = 'id_ID';
    } else if (value === 'Italian') {
      this.abbreviatedLang = 'it_IT';
    } else if (value === 'Japanese') {
      this.abbreviatedLang = 'ja_JP';
    } else if (value === 'Korean') {
      this.abbreviatedLang = 'ko_KR';
    } else if (value === 'Norwegian') {
      this.abbreviatedLang = 'nb_NO';
    } else if (value === 'Polish') {
      this.abbreviatedLang = 'pl_PL';
    } else if (value === 'Portuguese - Portugal') {
      this.abbreviatedLang = 'pt_PT';
    } else if (value === 'Portuguese - Brazil') {
      this.abbreviatedLang = 'pt_BR';
    } else if (value === 'Romanian') {
      this.abbreviatedLang = 'ro_RO';
    } else if (value === 'Russian') {
      this.abbreviatedLang = 'ru_RU';
    } else if (value === 'Slovak') {
      this.abbreviatedLang = 'sk_SK';
    } else if (value === 'Spanish') {
      this.abbreviatedLang = 'es_ES';
    } else if (value === 'Spanish - Mexico') {
      this.abbreviatedLang = 'es_MX';
    } else if (value === 'Swedish') {
      this.abbreviatedLang = 'sv_SE';
    } else if (value === 'Turkish') {
      this.abbreviatedLang = 'tr_TR';
    } else if (value === 'Thai') {
      this.abbreviatedLang = 'th_TH';
    } else if (value === 'Ukrainian') {
      this.abbreviatedLang = 'uk_UA';
    } else if (value === 'Vietnamese') {
      this.abbreviatedLang = 'vi_VN';
    } else if (value === 'Icelandic') {
      this.abbreviatedLang = 'is_IS';
    }

    if (this.autoID) {
      this.checkDuplicateLang(index, this.abbreviatedLang);
      this.editLanguageList.set(index, this.abbreviatedLang);

    } else {

      this.checkDuplicateLang(index, this.abbreviatedLang);
      this.languageList.set(index, this.abbreviatedLang);
    }
  }

  addLanguage() {
    this.checkInputEmptyError = true;
    this.disableSubmit = true;
    this.langIsSelected = true;
    this.disableAddLang = true;
    if (this.langList.length <= 29) {
      this.langList.push({ listOflan: this.languages, selectedLan: this.initLang, name: '', duplicateLan: false });
      this.newAttribute = {};
    }

  }

  checkDuplicateLang(index, value) {
    if (this.autoID) {
      this.langList[index].duplicateLan = Array.from(this.editLanguageList.values()).includes(value);
      this.checkError = Array.from(this.editLanguageList.values()).includes(value);
    } else {

      this.langList[index].duplicateLan = Array.from(this.languageList.values()).includes(value);
      this.checkError = Array.from(this.languageList.values()).includes(value);
    }
  }


  removeLang(index) {
    if (this.autoID) {
      let tempMap = new Map();
      let tempMap2 = new Map();
      this.editLanguageList.delete(index);
      this.editDisplayValue.delete(index);
      Array.from(this.editDisplayValue.values())
        .forEach((value, index) => {
          tempMap.set(index, value);
        })
      this.editDisplayValue = tempMap;
      Array.from(this.editLanguageList.values())
        .forEach((value, index) => {
          tempMap2.set(index, value);
        })
      this.editLanguageList = tempMap2;
    } else {
      let tempMap = new Map();
      let tempMap2 = new Map();
      this.languageList.delete(index);
      this.displayValue.delete(index);
      Array.from(this.displayValue.values())
        .forEach((value, index) => {

          tempMap.set(index - 1, value);
        })
      this.displayValue = tempMap;
      Array.from(this.languageList.values())
        .forEach((value, index) => {
          tempMap2.set(index, value);
        })
      this.languageList = tempMap2;
    }
    this.langList.splice(index, 1);
    this.disableSubmit = false;
    this.disableAddLang = false;
    this.langIsSelected = false;
    this.checkInputEmptyError = this.autoID ? Array.from(this.editDisplayValue.values()).includes('') : Array.from(this.displayValue.values()).includes('');
  }


  addSystemModel() {
    this.disableSubmit = true;
    if (!this.autoID) {
      if (this.systemModelList.length < 100) {
        this.systemModelList.push(this.newModel);
        this.newModel = {};
        this.checkEmptyInputField = true;
      }
    } else {
      if (this.allValues.length < 100) {
        this.newInputModel = '';
        this.allValues.push(this.newInputModel);
        this.checkEmptyInputField = true;
      }
    }
  }

  getModelSkU(index, data) {
    if (this.autoID) {
      data = data.trim(' ');
      this.makeMandatory(data);
      this.checkduplicateSku = !(Array.from(this.editModelSKUList.values()).includes(data))
      this.editModelSKUList.set(index, data);
      let tem = Array.from(this.editModelSKUList.values())
      this.checkduplicateSku = (tem.length === new Set(tem).size);

      this.checkInputEmptyError = data === '' || data === ' ' ? true : Array.from(this.editModelSKUList.values()).includes('');
    } else {
      data = data.trim(' ');
      this.makeMandatory(data);
      this.checkduplicateSku = !(Array.from(this.modelSKUList.values()).includes(data));
      this.modelSKUList.set(index, data);
      let listArr = Array.from(this.modelSKUList.values());
      this.checkInputEmptyError = data === '' || data === ' ' ? true : Array.from(this.modelSKUList.values()).includes('');
      if (index !== -1)
        this.disableAdd = listArr.length === new Set(listArr).size;
    }

  }

  removeModel(index) {
    this.disableSubmit = false;
    this.checkEmptyInputField = false;
    if (this.autoID) {
      let tempMap = new Map();
      this.editModelSKUList.delete(index);
      Array.from(this.editModelSKUList.values())
        .forEach((value, index) => {
          tempMap.set(index, value);
        })
      this.editModelSKUList = tempMap;
      this.allValues.splice(index, 1);
      let tem = Array.from(this.editModelSKUList.values())
      this.checkInputEmptyError = Array.from(this.editModelSKUList.values()).includes('');
      this.disableAdd = !this.checkInputEmptyError;
      this.checkduplicateSku = (tem.length === new Set(tem).size);

    } else {

      let tempMap2 = new Map();
      this.modelSKUList.delete(index);
      Array.from(this.modelSKUList.values())
        .forEach((value, index) => {
          tempMap2.set(index - 1, value);
        })
      this.modelSKUList = tempMap2;
      this.systemModelList.splice(index, 1);
      let tem = Array.from(this.modelSKUList.values())
      this.checkInputEmptyError = Array.from(this.modelSKUList.values()).includes('');
      this.disableAdd = !this.checkInputEmptyError;
      this.checkduplicateSku = (tem.length === new Set(tem).size);
    }
  }
  makeMandatory(data) {
    if (data == "") {
      this.disableSubmit = true;
      this.checkEmptyInputField = true;
      this.disableAddLang = true;
      this.checkInputEmptyError = true;
    } else {
      this.disableSubmit = false;
      this.checkEmptyInputField = false;
      this.disableAddLang = false;
      this.checkInputEmptyError = false;
    }

  }


  goBack() {
    this.router.navigate([RouterConstants.MODEL_SKU_INFO_LINK]);
  }

  sendDataToDE() {
    this.isEditFlow.emit(true);
    if (this.autoID) {
      this.editData = this.modelSKUInfoForm.value as AddNewModelSKU;
      let langValue = Array.from(this.editLanguageList.values());
      let displayVal = Array.from(this.editDisplayValue.values());
      this.langList.forEach(element => {
        displayVal.push(element.name);
      });

      let tempVar = [...langValue.map((v, i) => ({ [v]: displayVal[i] }))]
      let totalValue = Object.assign({}, ...tempVar);
      this.editData.systemID = this.valueOfSystemID;
      this.editData.operatingSystem = Array.from(this.isOperatingSystem.keys()).join(',');
      this.editModelSKUListData = Array.from(this.editModelSKUList.values());
      if (this.editModelSKUListData.length === 1) {
        this.editData.systemModels = this.editModelSKUListData[0];
      } else {
        this.editData.systemModels = JSON.stringify(this.editModelSKUListData)
      }
      totalValue = Object.assign({ en_US: this.editEnglish }, totalValue);
      this.editData.displayName = JSON.stringify(totalValue);

      //USe this.editData to populate the to be edited data
      this.oemservice.editModelSKU(this.editData)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(res => {

        })
      this.setSideNavValue.emit('upload_thumbnail');
    } else {
      let langValue = Array.from(this.languageList.values());
      let displayVal = Array.from(this.displayValue.values());
      this.tempVar = [...langValue.map((k, i) => ({ [k]: displayVal[i + 1] }))];
      let totalValue = Object.assign({}, ...this.tempVar);
      totalValue = Object.assign({ en_US: this.englishValue }, totalValue);
      this.isSubmitted = true;
      this.partnerName = this.partnerName.split(' ').join('');
      this.systemIDToDE = `${this.partnerName.toUpperCase()}${'_'}${this.modelSKUInfoForm.controls.systemID.value}`;
      this.payload = this.modelSKUInfoForm.value as AddNewModelSKU;
      this.payload.systemID = this.systemIDToDE;
      this.payload.configurations = '{}';
      this.payload.operatingSystem = Array.from(this.isOperatingSystem.keys()).join(',');
      this.modelSKUListData = Array.from(this.modelSKUList.values());
      if (this.modelSKUListData.length === 1) {
        this.payload.systemModels = this.modelSKUListData[0];
      } else {
        this.payload.systemModels = JSON.stringify(this.modelSKUListData);
      }

      this.payload.displayName = JSON.stringify(totalValue);

      this.oemservice.SendModelSKUInfoTODE(this.payload).
        pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(res => {
          if (res.responseContext.success) {
            this.GeneratedAutoId = res.modelSKU.autoID;
            this.oemStore.oemStoreData = this.GeneratedAutoId;
            this.oemservice.setAutoId(this.GeneratedAutoId);
            this.setSideNavValue.emit('upload_thumbnail');
          }
        },
          (err) => {
            if (err.responseContext.exceptionResponse.errorMessage) {
              this.isSystemIdExists = true;
              this.errorCheckSyatemId = true;
            }
          });
      this.googleAnalyticsService.newModelSkuInfoAdded(this.payload.displayName);
    }

  }

}
